import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ServiceRequestNotAvailablePage from './pages/ServiceRequestNotAvailablePage';

export const ServiceRequestNotAvailableViewRoutes: React.FC = () => (
  <Routes>
    <Route path="/" element={<ServiceRequestNotAvailablePage />} />
  </Routes>
);
